import { useHistory } from "react-router";

import { MainLayout } from "layouts";
import { DataTable } from "components/DataTable";
import { Button } from "components/Button";

import { useRecepiesPage } from "./hooks";
import { columns } from "./helpers";
import { TextInput } from "components/TextInput";

export const RecipesPage = () => {
  const {
    data,
    pagination,
    search,
    onRowClick,
    onNextClick,
    onPreviousClick,
    onTableHeaderClick,
    onSearchChanged,
  } = useRecepiesPage();
  const history = useHistory();

  return (
    <MainLayout
      title="Recipes"
      rightElement={
        <Button
          label="Create new"
          onClick={() => history.push("/recipes/-1")}
        />
      }
    >
      <TextInput
        containerClassName="max-w-sm mb-5"
        type="text"
        name="search"
        placeholder="Search"
        value={search.search}
        onChage={onSearchChanged}
      />
      <DataTable
        columns={columns(onTableHeaderClick)}
        data={data}
        onRowClick={onRowClick}
        pagination={pagination}
        nextClick={onNextClick}
        previousClick={onPreviousClick}
      />
    </MainLayout>
  );
};
